import { MyProfileAvatar } from '@/components/my-profile-avatar.tsx';
import { QuickActionsNav } from '@/components/quick-actions-nav.tsx';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb.tsx';
import { Link, useParams } from 'react-router';
import { EditPlantForm } from '@/features/plants/components/plant-management/edit/plant-form-edit.tsx';
import { Button } from '@/components/ui/button.tsx';
import { ChevronLeft } from 'lucide-react';
import { useMediaQuery } from '@/hooks/use-media-query.tsx';
import { useGetPlantQuery } from '@/features/plants/hooks/queries/[plantId]/use-get-plant.ts';

export const EditPlant = () => {
  const { plantId } = useParams();
  const { data: plant } = useGetPlantQuery({ plantId: plantId ?? '' });
  const isMobile = useMediaQuery('(max-width:640px)');

  return (
    <div className="w-full gap-2 px-4 pt-3 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          {!isMobile && (
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild className="link-underline">
                    <Link to="/dashboard">Dashboard</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbLink asChild className="link-underline">
                    <Link to="/plants">Plants</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbLink asChild className="link-underline">
                    <Link to={`/plants/${plantId}`}>{plant?.basicDetails?.name}</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="font-semibold">Edit power plant</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          )}
          {isMobile && (
            <Button variant="outline" asChild className="size-8 p-0">
              <Link to="/plants">
                <ChevronLeft />
              </Link>
            </Button>
          )}

          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div>
          <EditPlantForm plantId={plantId || ''} />
        </div>
      </div>
    </div>
  );
};

export default EditPlant;
